import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const GTMTracker = () => {
    const location = useLocation();

    const isMounted = useRef(false);

    useEffect(() => {
        if (isMounted.current) {
            if (window.dataLayer) {
                window.dataLayer.push({
                    event: 'page_view',
                    page_path: location.pathname + location.search
                });
            }
        } else {
            isMounted.current = true;
        }
    }, [location]);

    return null;
};

export default GTMTracker;
